/**
 * Hacky solution to provide compatibility with libraries affected by rollup/cjs bug.
 * @see https://github.com/vitejs/vite/issues/2139
 *
 * @param value
 */
export function interopDefault<T>(value: T): T {
  return (value as any).default;
}
